"use client"

import Link from "next/link"
import type { ComponentProps } from "react"
import { replaceConsumerTab } from "../lib/consumer-navigation.ts"

export const ConsumerTabLink = ({ href, ...props }: Omit<ComponentProps<typeof Link>, "href" | "onNavigate"> & { readonly href: string }) => (
  <Link
    {...props}
    href={href}
    onNavigate={(event) => {
      if (replaceConsumerTab(href)) event.preventDefault()
    }}
    prefetch={false}
    replace
    scroll={false}
  />
)
